export default __webpack_public_path__ + "static/media/wallet.2496c52a.svg";